import $ from 'jquery';
import React from 'react';
import Chart from "react-google-charts";
import {UserToken,getUserObjData,getAccessFunctions} from '../function_lib/userToken';
import {CallMapMethod, GetDateDifferecec,CallMapMethod_CBack,_getInitParam} from '../function_lib/common_lib';
import Header from './header';
import Footer from './footer';
import LogoImg from '../assets/images/logo_p_small.png';
import defaultPic from '../assets/images/9.png';

import Upcoming_Events from '../components/upcoming_events';
import Emp_On_Leave from '../components/emp_on_leave';
import Broadcast from '../components/broadcast';
import Mobile_Widgets from '../components/mobile_widgets';
import {LineChart,BarChart,Comparison_BarChart,Top_Overall_BarChart} from '../components/graphical_reports';
import {Comp_Map_Marker} from '../components/comp_map_marker';
import castrol1 from '../assets/images/sm_castrol1.jpg';

import './dashboard_new.css';

//import UserManual from '../assets/Operational_Instructions.pdf';

let loginUser="";
let userObject="";
let companyName="";
let userType="";
let clsDashboardNew;

let _chkOrderCall=false;
let _chkAnalyticsCall=false;
let _chkCmsCall=false;
let _initSettings={};
const refreshInterval = 15 * 60 * 1000; // 15 minutes in ms
let nextRefreshTime = Date.now() + refreshInterval;
class Comp_Dashboard extends React.Component{
    forceUpdateHandler(){
        this.forceUpdate();
      };
    constructor(props){
        super(props);
        clsDashboardNew=this;
        _initSettings=_getInitParam();
        //alert(JSON.stringify(_initSettings.app_settings.settings.dashboard));
        _initSettings=_initSettings.app_settings.settings.dashboard;
        this.state={creditBalance:[],stCurrentMonthOilChange_V:[]
          ,stTillDateTo:[],stMachineCounts:[]
        ,stQlcList:[],stQulcActive:"0",stQlcInactive:"0"};
        //this.state={no_entities:0,no_clients:0,no_vendors:0}
        this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
        userType="0";
        
        if(localStorage.getItem("userData")!=null){
          userObject= getUserObjData();
          //alert(JSON.stringify(userObject));
          loginUser=userObject[0].first_name;
          companyName=userObject[0].first_name;
      }

      let ret= getAccessFunctions();
      //alert(ret);
     
    }
   
getDashBoardPerfo(){
  var map=[];
  map.push({name:"curl_type",value:"getGraphDataReport"});
  map.push({name:"res_func",value:"callBackrrr"});
  map.push({name:"local_token",value:userObject[0].app_user_id});
  map.push({name:"gb_token",value:userObject[0].app_user_id});
  
  //map.push({name:"acc_inf_id",value:userObject[0].app_user_id});
  
  map["res_func"]="callBackrrr";
  map["curl_type"]="getGraphDataReport";

  CallMapMethod_CBack(clsDashboardNew,map,function(data,msg){
    
    if(data!=="0" && data!==""){
      let jsData=JSON.parse(data);
      
      
    
      
//alert(JSON.stringify(jsData["qlc_list"]));
      

      clsDashboardNew.setState({      
        
      stCurrentMonthOilChange_V:jsData["current_month"],
        stMachineCounts:jsData["machine_counts"],
        stQlcList:jsData["qlc_list"],
        stQulcActive:jsData["qlc_active_counts"],
        stQlcInactive:jsData["qlc_inactive_counts"]
      });

    }
  })

}
// Show countdown in "MM:SS" format
updateTimerDisplay() {
  const now = Date.now();
  let diff = Math.max(0, Math.floor((nextRefreshTime - now) / 1000)); // in seconds

  const minutes = Math.floor(diff / 60);
  const seconds = diff % 60;

  document.getElementById("count_notification").innerText =
    `Next refresh in ${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;

  // If reached 0, schedule next refresh
  if (diff <= 0) {
    nextRefreshTime = Date.now() + refreshInterval; // reset for next cycle
  }
}

      componentDidMount(){
        
        this.getDashBoardPerfo();
        $("#divEmployee").show();
        this.forceUpdateHandler();

        // Set refresh interval (15 minutes in ms)

        const refreshInterval = 15 * 60 * 1000; // 15 minutes in ms
let nextRefreshTime = Date.now() + refreshInterval;
setInterval(this.updateTimerDisplay, 1000);

this.dashboardInterval = setInterval(() => {
  this.getDashBoardPerfo();
  nextRefreshTime = Date.now() + refreshInterval; // sync countdown with actual refresh
}, refreshInterval);
      }

      componentWillUnmount() {
        // Clear the interval to prevent memory leaks
        //clearInterval(this.dashboardInterval);
    }
   //Get no of Entities/Client/Vendos
     
   
     

    render(){
        return(<div className="wrapper">
            <Header/>
            {/* <Mobile_Widgets/> */}
            <div class="content" style={{"min-height":"150px"}}>
            <div class="container-fluid mt-4">
                   {/* new acta component */}
                   <div className="row">
                    <div className="col-md-12">
                      
                      <div className="row">


{/* graph tesitng */}
{_initSettings["dau"]==="yes"?
           <div className="col-md-6">
            <div className="card card-widget widget-user-2">
              <div className="widget-user-header bg-warning">
                <div className="widget-user-image">
                
                 <span className="info-box-icon text-red bg-info1 elevation-11"><i className="fa fa-area-chart fa-3x white" aria-hidden="true"></i></span>
                  
                 
                </div>
                <h3 className="widget-user-username"></h3>
                <h5 className="widget-user-desc white">{"Express Network"}</h5>
              </div>
              <div style={{backgroundColor:"#fff",textAlign:"center"}} className="card-footer p-0">
              <center>
              <Comp_Map_Marker qlcList={this.state.stQlcList}/>
              </center>
              
              </div>
            </div>
          </div>
          :''}
{/* end of bar chart */}

   {/* dau view */}
   {(_initSettings["dau"]==="yes" && 0===0)?<>
   {/* <div class="col-md-2"></div> */}
           <div className="col-md-6">
            <div className="card card-widget widget-user-2">
              <div className="widget-user-header bg-warning">
                <div className="widget-user-image">
                
                 <span className="info-box-icon text-red bg-info1 elevation-11"><i className="fa fa-cogs fa-3x white" aria-hidden="true"></i></span>
                  
                 
                </div>
                <h3 className="widget-user-username"></h3>
                <h5 className="widget-user-desc white">{"Oil Change All India"}</h5>
              </div>
              <div className="card-footer p-0">
                <ul className="nav flex-column">

                  {this.state.stMachineCounts.length>0?
                  <li className="nav-item">
                    <a href="../state_analysis" className="nav-link pb-2 pt-4">
                    <h5>Total No. of Machines Installed 
                    <span className="float-right badge bg-primary">{this.state.stMachineCounts[0]["count_machines"]}</span>
                    </h5>
                    </a>
                  </li>:''}
                  {this.state.stMachineCounts.length>0?
                  <li className="nav-item">
                    
                    <a href={"../active_machines?rf="+btoa("active")} className="nav-link pb-2 pt-4">
                    <h5>
                    No. of Machines Live <span className="float-right badge bg-primary">{this.state.stQulcActive}</span>
                    </h5>
                    </a>
                  </li>:''}

                  {this.state.stMachineCounts.length>0?
                  <li className="nav-item">
                    
                    <a href={"../inactive_machines?rf="+btoa("inactive")} className="nav-link pb-2 pt-4">
                    <h5>
                    No. of Machines Inactive <span className="float-right badge bg-primary">{this.state.stQlcInactive}</span>
                    </h5>
                    </a>
                  </li>:''}
                  
                  {this.state.stCurrentMonthOilChange_V.length>0?<>
                  <li className="nav-item">
                    
                    <a href={"../regional_analysis?rf="+btoa("this_month")} className="nav-link pb-2 pt-4">
                    <h5>
                      Oil Changes – This Month <span className="float-right badge bg-primary">{this.state.stCurrentMonthOilChange_V[0]["count_cc"]}</span>
                    </h5>
                    </a>
                  </li>
                  </>:''}
                </ul>
               
              </div>
            </div>
            {/* <img width={"100%"} src={castrol1}/> */}
          </div>
           </>
          :''}

{/*end dau view */}

                      {_initSettings["welcome_msg"]==="yes"?
                        <div className="col-md-12">
                          {/* Welcome of Fast RC Direct */}
                        </div>:''}
                    {/* user compoentnet  */}
            {/* component type */}
        {/* image thumb */}
  {_initSettings["dau"]==="yes"?<>
           {/* <div className="col-md-4">
            <div className="card card-widget widget-user-2">
             
              <img src={castrol1}/>
             
            </div>
          </div> */}
           </>
          :''}

{/*end of image*/}  
        
         
            
         

  






            {/* end of component tyep */}
</div>
</div>
{/* end of compaign */}
</div>
                {/* end of new acta component */}

{/* <!-- /.content --> */}
</div>
      </div> 
        <Footer/>
        
      </div>)
    }
}
export default Comp_Dashboard